// components/ActionButtons.jsx
import { useState } from "react";
import { fmt } from "../mockData";

export default function ActionButtons({ rec, onApprove, onReject, onModify }) {
  const [editing, setEditing] = useState(false);
  const [price,   setPrice]   = useState(rec.recommended_price);

  if (rec.status !== "PENDING") {
    const cfg = {
      APPROVED: { label: "✓ Approved", color: "#15803d" },
      MODIFIED: { label: "✏ Modified", color: "#1d4ed8" },
      REJECTED: { label: "✕ Rejected", color: "#94a3b8" },
    }[rec.status] || {};
    return (
      <span style={{ fontSize: 12, color: cfg.color, fontWeight: 600, fontStyle: "italic" }}>
        {cfg.label}
      </span>
    );
  }

  if (editing) return (
    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
      <input
        type="number" value={price}
        onChange={e => setPrice(e.target.value)}
        style={{
          width: 90, padding: "5px 8px",
          border: "1.5px solid #2563eb", borderRadius: 6,
          fontSize: 12, outline: "none", fontFamily: "'DM Mono',monospace",
          fontWeight: 600,
        }}
      />
      <button
        className="dp-btn dp-btn-primary dp-btn-sm"
        onClick={() => { onModify(rec.id, price); setEditing(false); }}
      >
        Save
      </button>
      <button
        className="dp-btn dp-btn-ghost dp-btn-sm"
        onClick={() => { setPrice(rec.recommended_price); setEditing(false); }}
      >
        ✕
      </button>
    </div>
  );

  return (
    <div style={{ display: "flex", gap: 5 }}>
      <button className="dp-btn dp-btn-success dp-btn-sm" onClick={() => onApprove(rec.id)}>
        ✓ Approve
      </button>
      <button className="dp-btn dp-btn-outline dp-btn-sm" onClick={() => setEditing(true)}>
        ✏ Modify
      </button>
      <button className="dp-btn dp-btn-danger dp-btn-sm" onClick={() => onReject(rec.id)}>
        ✕
      </button>
    </div>
  );
}
